import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../analytics';

// Sends a page view on every route change (the app is a single-page app). Renders nothing.
const AnalyticsRouteTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

export default AnalyticsRouteTracker;
